export const CALCULATION_ROUTE_NAMES = ['calculation-detail', 'calculation-result'] as const

export const PROJECT_SCOPED_ROUTE_NAMES = [
  'project-detail',
  'calculation-index',
  'user-management',
  'project-hardware-profiles',
  ...CALCULATION_ROUTE_NAMES
] as const

export const HEADER_DRAWER_ROUTE_NAMES = [
  'project-index',
  'global-hardware-profiles',
  'calculation-index',
  'user-management',
  'project-hardware-profiles',
  ...CALCULATION_ROUTE_NAMES
] as const
